module.exports = __webpack_public_path__ + "medicover_test.jpeg";